export default "__VITE_ASSET__BHDO_Voj__"